<template>
  <div id="invoice-page">
    <vx-card>
      <!-- INVOICE METADATA -->
      <div class="vx-row leading-loose p-base">
        <div class="vx-col w-full md:w-1/4 mt-base">
          <img
            :src="
              settings === null
                ? require('@/assets/images/logo/logo.png')
                : settings.logo_path
            "
            alt="urblock-logo"
            height="auto"
            width="150px"
          />
        </div>
        <div class="vx-col w-full md:w-1/4">
          <h1 class="mb-4">Factura</h1>
          <h5>Cliente</h5>
          <div class="invoice__recipient-info mt-4">
            <p>
              {{ user.firstName + " " + user.lastName }}
            </p>
            <div class="invoice__company-info">
              <p>
                {{ conjunto.calle + " " + conjunto.numero }}
              </p>
              <p>
                {{
                  conjunto.ciudad +
                    " " +
                    conjunto.departamento +
                    " " +
                    conjunto.pais
                }}
              </p>
            </div>
          </div>
          <div class="invoice__recipient-contact">
            <p class="flex items-center">
              <feather-icon
                icon="MailIcon"
                svg-classes="h-4 w-4"
              ></feather-icon>
              <span class="ml-2">
                {{ user.email }}
              </span>
            </p>
            <p class="flex items-center">
              <feather-icon
                icon="PhoneIcon"
                svg-classes="h-4 w-4"
              ></feather-icon>
              <span class="ml-2">
                {{ user.phone | phone }}
              </span>
            </p>
          </div>
        </div>
        <div class="vx-col w-full md:w-1/4 mt-12">
          <h5 class="capitalize">Conjunto {{ conjunto.nombre }}</h5>
          <div class="invoice__company-info my-4">
            <p>
              {{ conjunto.calle + " " + conjunto.numero }}
            </p>
            <p>
              {{
                conjunto.ciudad +
                  " " +
                  conjunto.departamento +
                  " " +
                  conjunto.pais
              }}
            </p>
          </div>
          <div class="invoice__company-contact">
            <p class="flex items-center">
              <feather-icon
                icon="MailIcon"
                svg-classes="h-4 w-4"
              ></feather-icon>
              <span class="ml-2">{{ conjunto.email }}</span>
            </p>
            <p class="flex items-center">
              <feather-icon
                icon="PhoneIcon"
                svg-classes="h-4 w-4"
              ></feather-icon>
              <span class="ml-2">
                {{ conjunto.telefono | phone }}
              </span>
            </p>
          </div>
        </div>
        <div class="vx-col w-full md:w-1/4 mt-12">
          <h6>FACTURA NO.</h6>
          <div class="invoice__invoice-detail">
            <p class="uppercase">
              {{ invoice.prefijo + "-" + invoice.sufijo }}
            </p>
            <h6 class="mt-4">FECHA DE EMISIÓN</h6>
            <p>{{ invoice.created_at | moment }}</p>
          </div>
        </div>
      </div>

      <!-- INVOICE CONTENT -->
      <div class="p-base">
        <!-- INVOICE TASKS TABLE -->
        <vs-table hover-flat :data="products">
          <!-- HEADER -->
          <template slot="thead">
            <vs-th>Identificacion</vs-th>
            <vs-th>Descripcion</vs-th>
            <vs-th>Cantidad</vs-th>
            <vs-th>Precio Unitario</vs-th>
          </template>

          <!-- DATA -->
          <template slot-scope="{ data }">
            <vs-tr v-for="(tr, index) in data" :key="index">
              <vs-td class="w-1/4" :data="data[index].codigo">
                {{ data[index].identificador }}
              </vs-td>
              <vs-td class="w-1/4" :data="data[index].descripcion">{{
                data[index].description
              }}</vs-td>
              <vs-td class="w-1/6" :data="data[index].qty">
                {{ data[index].qty }}
              </vs-td>
              <vs-td class="w-1/6" :data="data[index].unityPrice">
                {{ data[index].unityPrice | numeralFormat("$ 0,0[.]00") }}
                COP
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <div class="vx-row leading-loose">
          <div class="vx-col w-full md:w-1/3 mt-base text-area">
            <p class="font-semibold">Observaciones</p>
            <p>{{ invoice.observations }}</p>
          </div>
          <div class="vx-col w-full md:w-2/3 mt-base">
            <!-- INVOICE SUMMARY TABLE -->
            <vs-table hover-flat class="w-1/2 ml-auto mt-4" :data="invoice">
              <vs-tr>
                <vs-th>SUBTOTAL</vs-th>
                <vs-td>
                  {{ invoice.subtotal | numeralFormat("$ 0,0[.]00") }}
                  COP
                </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-th>DESCTO ({{ invoice.disscount_percent }}%)</vs-th>
                <vs-td>
                  {{ invoice.disscount_total | numeralFormat("$ 0,0[.]00") }}
                  COP
                </vs-td>
              </vs-tr>
              <vs-tr>
                <th>TOTAL</th>
                <td>
                  {{ invoice.grand_total | numeralFormat("$ 0,0[.]00") }}
                  COP
                </td>
              </vs-tr>
            </vs-table>
          </div>
        </div>
      </div>

      <!-- INVOICE FOOTER -->
      <div
        class="invoice__footer text-center p-base"
        v-if="invoice.status !== 'completed' && user.role === 'customer'"
      >
        <div class="w-full flex justify-center">
          <img
            src="@/assets/images/pages/finances/secure-epayco.png"
            alt="Pago seguro con epayco"
            class="cursor-pointer"
            @click="makePaymentWithEpayco"
          />
        </div>
      </div>
      <div
        class="invoice__footer text-center p-base"
        v-else-if="invoice.status === 'completed'"
      >
        <div class="w-full flex justify-center">
          <table class="table-auto">
            <thead>
              <tr>
                <th class="px-4 py-2">Estado</th>
                <th class="px-4 py-2"># de Aprobación</th>
                <th class="px-4 py-2"># de Cuotas</th>
                <th class="px-4 py-2">Metodo de Pago</th>
                <th class="px-4 py-2">Fecha de Transacción</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="border px-4 py-2">
                  <span class="flex items-center px-2 py-1 rounded">
                    <div
                      class="h-3 w-3 rounded-full mr-2"
                      :class="[
                        invoice.status === 'pending'
                          ? 'bg-warning'
                          : invoice.status === 'completed'
                          ? 'bg-success'
                          : invoice.status === 'cancelled'
                          ? 'bg-danger'
                          : null
                      ]"
                    ></div>
                    {{
                      invoice.status === "pending"
                        ? "Pendiente"
                        : invoice.status === "completed"
                        ? "Pagada"
                        : invoice.status === "cancelled"
                        ? "Cancelada"
                        : null
                    }}
                  </span>
                </td>
                <td class="border px-4 py-2">
                  {{ payment_data.x_approval_code }}
                </td>
                <td class="border px-4 py-2">{{ payment_data.x_quotas }}</td>
                <td class="border px-4 py-2">
                  {{ payment_data.x_type_payment }}
                </td>
                <td class="border px-4 py-2">
                  {{ payment_data.x_fecha_transaccion | moment }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      URL: "http://backend.test",
      products: {},
      firstProduct: {},
      invoice: {},
      user: {},
      customer: {},
      conjunto: {},
      payment_data: {}
    };
  },
  computed: {
    ...mapState(["settings"])
  },
  methods: {
    makePaymentWithEpayco() {
      // initialize payment gateway
      var handler = ePayco.checkout.configure({
        key: "fbb26ec2033e0f77a283327c28a55801",
        test: process.env.NODE_ENV !== "production"
      });

      // set payment data
      var data = {
        //Parametros compra (obligatorio)
        name: this.firstProduct.identificador,
        description: this.firstProduct.description,
        invoice: this.invoice.prefijo + "-" + this.invoice.sufijo,
        currency: "cop",
        amount: this.invoice.grand_total,
        tax_base: "0",
        tax: "0",
        country: "co",
        lang: "es",

        //Onpage="false" - Standard="true (externo)"
        external: "false",

        // se redirige a donde se mostrara la respuesta
        //invoice-id
        extra1: this.invoice.id,
        extra2: this.customer.id,
        extra3: this.conjunto.id,
        response: this.URL + "/payment/confirmation",

        //Atributos cliente
        email_billing: this.customer.email,
        name_billing: this.customer.firstName + " " + this.customer.lastName,
        type_doc_billing: "cc",
        mobilephone_billing: this.customer.phone,
        number_doc_billing: this.customer.cc.split(".").join("")
      };
      handler.open(data);
    }
  },
  watch: {
    invoice: function(data) {
      this.products = JSON.parse(data.products);
      this.user = this.$store.state.user;
      this.customer = this.$store.state.invoice.users[0];
      this.conjunto = this.$store.state.invoice.conjunto[0];
      this.firstProduct = this.products[0];
    }
  },
  created() {
    this.$vs.loading({
      type: "corners",
      background: "rgba(45, 166, 179, 1)",
      color: "rgb(255, 255, 255)"
    });
    this.$store
      .dispatch("getInvoice", this.$route.params.id)
      .then(res => {
        this.invoice = res;
        const reference =
          this.$route.query.transaction_cde !== undefined
            ? this.$route.query.transaction_cde
            : this.invoice.payment.ref_payco;
        if (reference !== undefined) {
          this.$store
            .dispatch("GET_PAYEMENT_INFO", reference)
            .then(res => {
              this.payment_data = res.data;
            })
            .catch(err => {
              console.log(err.message);
            });
        }
        this.$vs.loading.close();
      })
      .catch(err => {
        console.log(err.message);
        this.$vs.loading.close();
      });
  },
  filters: {
    moment: function(date) {
      return moment(date)
        .locale("es")
        .format("LL");
    },
    phone: function(phone) {
      if (phone !== undefined) {
        return phone
          .replace(/[^0-9]/g, "")
          .replace(/(\d{3})(\d{3})(\d{4})/, "+57 ($1) $2-$3");
      }
    }
  }
};
</script>
